module.exports = __webpack_public_path__ + "static/media/organize_event_desktop.762df877.png";